<template>
  <div class="work-item" :class="{'is-choice':isOpenSwitch,'is-check':isCheck}" @click="clickWork">
    <template v-if="showGroup">
      <img v-if="workInfo.user_group === 1" class="group-icon" :src="require('@/assets/group_s.png')" alt="学生组">
      <img v-if="workInfo.user_group === 2" class="group-icon" :src="require('@/assets/group_t.png')" alt="专业组">
    </template>
    <img class="work-img" :src="workInfo.cover_img" :alt="workInfo.title">
    <div class="work-info">
      <p class="work-title">{{ workInfo.title }}</p>
      <p class="work-type">{{ workInfo.cate }}</p>
      <div class="work-num">
        <p class="work-num-item" v-if="workInfo.read_num">
          <img src="@/assets/num_icon_3.png" alt="查看">
          <span>{{ workInfo.read_num }}</span>
        </p>
      </div>
    </div>
    <div class="work-author-con">
      <div class="con-left">
        <img class="author-img" :src="workInfo.avatar" alt=" ">
        <span class="author-name">{{ workInfo.username }}</span>
      </div>
      <span>{{ relativeTime(workInfo.created_at) }}</span>
    </div>
  </div>
</template>

<script>
import 'dayjs/locale/zh-cn'
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime'
// 配置使用处理相对时间的插件
dayjs.extend(relativeTime)

// 配置使用中文语言包
dayjs.locale('zh-cn')
export default {
  name: "workItem",
  props:{
    isOpenSwitch:{
      type: Boolean,
      default: false
    },
    showGroup:{
      type: Boolean,
      default: true
    },
    workInfo:{
      type: Object,
      default:()=>{
        return {
          cover_img: '',
          title: '',
          cate: '',
          read_num: 0,
          username: '',
          created_at: '',
          user_group: 1
        }
      }
    },
    checkWorksList:{
      type: Array,
      default:()=>[]
    },
    canToDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCheck: false
    }
  },
  computed: {
    // isCheck(){
    //   console.log(this.checkWorksList,this.workInfo.id)
    //   return this.checkWorksList.includes(this.workInfo.id)
    // }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    relativeTime(value){
      return dayjs().to(dayjs(value))
    },
    clickWork(){
      if(this.canToDetail){
        this.$router.push({name:'worksDetail',query:{id:this.workInfo.id}})
      }else {
        this.$emit('clickWork',this.workInfo)
      }
    },
  },
  watch:{
    checkWorksList:{
      handler(newVal){
        this.isCheck = newVal.includes(this.workInfo.id)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.work-item {
  width: 400px;
  margin-right: 120px;
  margin-bottom: 60px;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  .group-icon {
    display: block;
    width: 23px;
    position: absolute;
    right: 21px;
    top: 0;
  }
  &.is-choice {
    position: relative;
    &::after {
      content: '';
      width: 25px;
      height: 25px;
      border: 1px solid #707070;
      background-color: #fff;
      border-radius: 50%;
      position: absolute;
      right: 25px;
      top: 15px;
    }
    &.is-check {
      &::after {
        width: 27px;
        height: 27px;
        background: url(~@/assets/check_icon.png) no-repeat center center;
        border: unset;
        background-size: 27px;
      }
    }
  }
  &:nth-of-type(3n){
    margin-right: 0;
  }
  .work-img {
    display: block;
    width: 100%;
    height: 266px;
    object-fit: cover;
  }
  .work-info {
    padding: 18px 30px;
    height: 152px;
    background-color: $blockColor--2;
    .work-title {
      font-size: 14px;
      color: #444;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .work-type {
      font-weight: 300;
      font-size: 12px;
      color: $blockColor--3;
    }
    .work-num {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 22px;
      .work-num-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 14px;
        color: $blockColor--4;
        font-size: 12px;
        & > img {
          display: block;
          width: 14px;
          margin-right: 6px;
        }
      }
    }
  }
  .work-author-con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 0 32px;
    background-color: $bgColor-1;
    font-size: 12px;
    color: #000;
    font-weight: 300;
    .con-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .author-img {
        display: block;
        width: 24px;
        height: 24px;
        object-fit: cover;
      }
      .author-name {

        margin-left: 16px;
      }
    }

  }
}
</style>
